export const mpSearchData = {
  searchInput: {
    logo: "firsttype|keycount|jdworldwidev2|logo",
    searchbutton: "firsttype|keycount|jdworldwidev2|searchbutton",
  },
  filter:{
    comprehensive: "firsttype|keycount|jdworldwidesearchlist|comprehensive",
    sale: "firsttype|keycount|jdworldwidesearchlist|sale",
    comment: "firsttype|keycount|jdworldwidesearchlist|comment",
    winsdate: "firsttype|keycount|jdworldwidesearchlist|winsdate",
    price: "firsttype|keycount|jdworldwidesearchlist|price",
    stock: "firsttype|keycount|jdworldwidesearchlist|stock",
    delivery: "firsttype|keycount|jdworldwidesearchlist|delivery"
  }
}  